export const PROMOTED_GIGS_SOURCE = 'similar_gigs_top_carousel';
export const GIG_CARD_IMPRESSION_NAME = 'gig_page';
